
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {createSelector} from "reselect";
import Helpers from "../../../helpers/helperFunctions";
import _ from "lodash";


class MarketsList extends React.Component {
    constructor (props) {
        super(props);
        this.isGame = false;
        this.state = {
            filtered: null
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleFilter = _.debounce(this.handleFilter, 1000);
        this.clearSearchFiled = this.clearSearchFiled.bind(this);
    }
    clearSearchFiled () {
        this.setState({filtered: null});
    }
    handleFilter (value, marketNames) {
        const filteredData = marketNames.filter(item => item.marketName.toLowerCase().includes(value.toLowerCase()));
        this.setState({ filtered: filteredData });
    }
    handleChange (e, marketNames) {
        this.setState({ inputField: e }, () => this.handleFilter(this.state.inputField, marketNames));
    }
    shouldComponentUpdate (nextProps, nextState) {
        if (this.state.filtered !== nextState.filtered) {
            return true;
        }
        if (!this.isGame && nextProps.game) {
            this.isGame = true;
            return true;
        } else {
            return (nextProps.marketsNames) && (JSON.stringify(nextProps.marketsNames) !== JSON.stringify(this.props.marketsNames && this.props.marketsNames)) ||
                (JSON.stringify(nextProps.favoritesMarketsNames) !== JSON.stringify(this.props.favoritesMarketsNames));
        }
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

const mapStateToProps = (_, ownParams) => {
    return createSelector(
        [
            state => state.gameMarketsList[ownParams.selectorKey] && JSON.stringify((() => {
                let marketsName = [];
                if (ownParams.marketsFilter === "all") {
                    Helpers.objectToArray(state.gameMarketsList[ownParams.selectorKey]).forEach((marketGroup) => {
                        Object.keys(marketGroup).forEach(marketName => {
                            const [market] = marketGroup[marketName];
                            marketsName.push({ marketName, order: market.order });
                        });
                    });

                } else {
                    const groupMarketsList = state.gameMarketsList[ownParams.selectorKey][ownParams.marketsFilter] || {};
                    marketsName = Object.keys(groupMarketsList).map(key => {
                        const [first = {}] = groupMarketsList[key];
                        return {order: first.order, marketName: key};
                    });
                }
                return marketsName.sort((a, b) => a.order - b.order);
            })()),
            state => state.swarmData.data[ownParams.selectorKey] && JSON.stringify((() => {
                let Sport = state.swarmData.data[ownParams.selectorKey].sport,
                    SportData = Helpers.firstElement(Sport),
                    Region = SportData.region,
                    RegionData = Helpers.firstElement(Region),
                    Competition = RegionData.competition,
                    CompetitionData = Helpers.firstElement(Competition),
                    Game = CompetitionData.game;
                return {
                    ...Helpers.firstElement(Game),
                    alias: SportData.alias,
                    regionId: RegionData.id,
                    competitionId: CompetitionData.id
                };
            })()),
            state => Object.keys(state.favorites.marketType),
            state => state.terminal.boostedOddsGameIds
        ],
        (marketsNames, game, favoritesMarketsNames, boostedOddsGameIds) => {
            return {
                marketsNames: marketsNames && JSON.parse(marketsNames),
                game: game && JSON.parse(game),
                favoritesMarketsNames,
                boostedOddsGameIds
            };
        });
};

MarketsList.propTypes = {
    marketsFilter: PropTypes.string,
    selectorKey: PropTypes.string,
    marketsNames: PropTypes.array,
    favoritesMarketsNames: PropTypes.array
};

export default connect(mapStateToProps)(MarketsList);